<div mat-dialog-content>
  Loading..
</div>